webpackJsonp([128454401290669],{

/***/ 372:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _getClassName2 = __webpack_require__(12);
	
	var _getClassName3 = _interopRequireDefault(_getClassName2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(15);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(475);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _styleModuleImportMap = {
	  './Filter.module.scss': {
	    'filter': 'src-components-Filters-Filter----Filter-module---filter---223FJ',
	    'selected': 'src-components-Filters-Filter----Filter-module---selected---1NN2i'
	  }
	};
	
	
	var Filter = function Filter(_ref) {
	  var filter = _ref.filter,
	      applyFilter = _ref.applyFilter,
	      selected = _ref.selected;
	  return _react2.default.createElement(
	    'div',
	    {
	      onClick: applyFilter,
	      className: (0, _getClassName3.default)((0, _classnames2.default)('filter', { selected: selected }), _styleModuleImportMap)
	    },
	    filter
	  );
	};
	
	Filter.propTypes = {
	  filter: _propTypes2.default.string.isRequired,
	  applyFilter: _propTypes2.default.func.isRequired,
	  selected: _propTypes2.default.bool.isRequired
	};
	
	exports.default = Filter;
	module.exports = exports['default'];

/***/ }),

/***/ 475:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"filter":"src-components-Filters-Filter----Filter-module---filter---223FJ","selected":"src-components-Filters-Filter----Filter-module---selected---1NN2i"};

/***/ }),

/***/ 373:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Filter = __webpack_require__(372);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Filter).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ 374:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _helpers = __webpack_require__(16);
	
	var _Filter = __webpack_require__(373);
	
	var _Filter2 = _interopRequireDefault(_Filter);
	
	__webpack_require__(476);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Filters = function Filters(_ref) {
	  var filters = _ref.filters,
	      currentFilter = _ref.currentFilter,
	      _applyFilter = _ref.applyFilter;
	
	  var sorting = function sorting(_ref2) {
	    var x = _ref2[0],
	        xs = _ref2.slice(1);
	
	    return [x].concat(xs.sort());
	  };
	  var sortedFilters = sorting(filters);
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'src-components-Filters----Filters-module---filters---JfQcy' },
	    (0, _helpers.indexMap)(function (filter, index) {
	      return _react2.default.createElement(_Filter2.default, {
	        filter: filter,
	        key: index,
	        applyFilter: function applyFilter() {
	          return _applyFilter(filter);
	        },
	        selected: filter === currentFilter
	      });
	    }, sortedFilters)
	  );
	};
	
	Filters.propTypes = {
	  filters: _propTypes2.default.array.isRequired,
	  currentFilter: _propTypes2.default.string,
	  applyFilter: _propTypes2.default.func.isRequired
	};
	
	exports.default = Filters;
	module.exports = exports['default'];

/***/ }),

/***/ 476:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"filters":"src-components-Filters----Filters-module---filters---JfQcy"};

/***/ }),

/***/ 375:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Filters = __webpack_require__(374);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Filters).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ 780:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ramda = __webpack_require__(6);
	
	var R = _interopRequireWildcard(_ramda);
	
	var _gatsbyLink = __webpack_require__(11);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _PageWrap = __webpack_require__(24);
	
	var _PageWrap2 = _interopRequireDefault(_PageWrap);
	
	var _BlockTitle = __webpack_require__(22);
	
	var _BlockTitle2 = _interopRequireDefault(_BlockTitle);
	
	var _Filters = __webpack_require__(375);
	
	var _Filters2 = _interopRequireDefault(_Filters);
	
	var _placeholder = __webpack_require__(102);
	
	var _placeholder2 = _interopRequireDefault(_placeholder);
	
	var _routes = __webpack_require__(17);
	
	__webpack_require__(1182);
	
	var _RenderHireProductLink = __webpack_require__(275);
	
	var _webp = __webpack_require__(30);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RESET_NAME = 'All';
	
	var Category = function (_Component) {
	  _inherits(Category, _Component);
	
	  function Category() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Category);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      originalProducts: R.propOr([], 'data', _this.props),
	      visibleProducts: R.propOr([], 'data', _this.props),
	      filters: [],
	      filter: RESET_NAME,
	      format: 'jpg'
	    }, _this.applyFilter = function (filter) {
	      if (filter === RESET_NAME) {
	        _this.resetFilters();
	        return;
	      }
	      var originalProducts = _this.state.originalProducts;
	
	      var visibleProducts = originalProducts.filter(function (product) {
	        return R.equals(R.path(['node', 'template', '0', 'brand'], product), filter);
	      });
	
	      _this.setState({ filter: filter, visibleProducts: visibleProducts });
	    }, _this.renderProduct = function (product, index) {
	      var format = _this.state.format;
	
	      var slug = R.path(['node', 'slug'], product);
	
	      var _R$path = R.path(['node', 'template', '0'], product),
	          title = _R$path.title,
	          image = _R$path.image,
	          category = _R$path.category;
	
	      var src = R.pathOr(null, ['sizes', 'src'], image);
	      if (!src.includes('progressive')) {
	        src = src + ('&fm=' + format);
	      }
	      var productLink = (0, _RenderHireProductLink.renderHireProductLink)(slug, category);
	
	      return _react2.default.createElement(
	        'div',
	        { key: slug + '-' + index, className: 'src-components-HireCategory-Category----Category-module---product---2nmgK' },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: (0, _routes.productRoute)(productLink) },
	          _react2.default.createElement(
	            'div',
	            { className: 'src-components-HireCategory-Category----Category-module---image-wrap---2mSrR' },
	            _react2.default.createElement('div', {
	              className: 'src-components-HireCategory-Category----Category-module---image---1oFzh',
	              style: { backgroundImage: 'url(' + (src || _placeholder2.default) + ')' }
	            })
	          ),
	          _react2.default.createElement(
	            'h4',
	            { className: 'src-components-HireCategory-Category----Category-module---product-title---2jlDf' },
	            title
	          )
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Category.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    var filters = this.props.filters;
	
	    filters.unshift(RESET_NAME);
	
	    this.setState({ filters: filters });
	    (0, _webp.supportsWebp)(function (isSupported) {
	      if (isSupported) {
	        _this2.setState({ format: 'webp' });
	      }
	    });
	  };
	
	  Category.prototype.resetFilters = function resetFilters() {
	    var visibleProducts = this.state.originalProducts;
	    this.setState({
	      visibleProducts: visibleProducts,
	      filter: RESET_NAME
	    });
	  };
	
	  Category.prototype.render = function render() {
	    var category = this.props.category;
	    var _state = this.state,
	        filters = _state.filters,
	        filter = _state.filter,
	        visibleProducts = _state.visibleProducts;
	
	    var takeTitle = R.path(['node', 'template', '0', 'title']);
	    var sorting = function sorting(a, b) {
	      return R.pipe(takeTitle, function (title) {
	        return title.localeCompare(takeTitle(b), undefined, { numeric: true });
	      })(a);
	    };
	    var sortVisibleProducts = visibleProducts.sort(function (a, b) {
	      return sorting(a, b);
	    });
	
	    return _react2.default.createElement(
	      _PageWrap2.default,
	      null,
	      _react2.default.createElement(_BlockTitle2.default, { title: category, DynamicTag: 'h1' }),
	      R.not(R.isEmpty(sortVisibleProducts)) ? _react2.default.createElement(
	        _react.Fragment,
	        null,
	        _react2.default.createElement(_Filters2.default, { filters: filters, applyFilter: this.applyFilter, currentFilter: filter }),
	        _react2.default.createElement(
	          'div',
	          { className: 'src-components-HireCategory-Category----Category-module---products---2tQw8' },
	          sortVisibleProducts.map(this.renderProduct)
	        )
	      ) : _react2.default.createElement(
	        'span',
	        { className: 'src-components-HireCategory-Category----Category-module---none-found---BC603' },
	        'No products found'
	      )
	    );
	  };
	
	  return Category;
	}(_react.Component);
	
	Category.propTypes = {
	  data: _propTypes2.default.array.isRequired,
	  filters: _propTypes2.default.array.isRequired
	};
	
	exports.default = Category;
	module.exports = exports['default'];

/***/ }),

/***/ 1182:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"products":"src-components-HireCategory-Category----Category-module---products---2tQw8","product":"src-components-HireCategory-Category----Category-module---product---2nmgK","image":"src-components-HireCategory-Category----Category-module---image---1oFzh","image-wrap":"src-components-HireCategory-Category----Category-module---image-wrap---2mSrR","product-title":"src-components-HireCategory-Category----Category-module---product-title---2jlDf","none-found":"src-components-HireCategory-Category----Category-module---none-found---BC603"};

/***/ }),

/***/ 781:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Category = __webpack_require__(780);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Category).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ 782:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ramda = __webpack_require__(6);
	
	var R = _interopRequireWildcard(_ramda);
	
	var _Category = __webpack_require__(781);
	
	var _Category2 = _interopRequireDefault(_Category);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var takeBrandsFromProducts = R.pipe(R.defaultTo([]), R.map(R.path(['node', 'template', '0', 'brand'])), R.reject(R.isNil), R.uniq);
	
	var HireCategory = function HireCategory(_ref) {
	  var category = _ref.category,
	      products = _ref.products;
	  return _react2.default.createElement(
	    'section',
	    null,
	    _react2.default.createElement(_Category2.default, { category: category, data: products, filters: takeBrandsFromProducts(products) })
	  );
	};
	
	HireCategory.propTypes = {
	  products: _propTypes2.default.array.isRequired,
	  category: _propTypes2.default.string
	};
	
	exports.default = HireCategory;
	module.exports = exports['default'];

/***/ }),

/***/ 783:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _HireCategory = __webpack_require__(782);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_HireCategory).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ 885:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ramda = __webpack_require__(6);
	
	var R = _interopRequireWildcard(_ramda);
	
	var _Seo = __webpack_require__(35);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _HireCategory = __webpack_require__(783);
	
	var _HireCategory2 = _interopRequireDefault(_HireCategory);
	
	var _ContactDetails = __webpack_require__(89);
	
	var _ContactDetails2 = _interopRequireDefault(_ContactDetails);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HireCategoryPage = function HireCategoryPage(_ref) {
	  var data = _ref.data;
	
	  var metaTitle = R.pathOr('', ['contentfulPage', 'metaTitle'], data);
	  var metaDescription = R.pathOr('', ['contentfulPage', 'metaDescription'], data);
	  var canonicalUrl = R.pathOr('', ['contentfulPage', 'canonicalUrl'], data);
	  var category = R.pathOr('', ['contentfulPage', 'template', '0', 'category'], data);
	  var contactDetails = R.pathOr(null, ['contentfulPage', 'template', '0', 'contactDetails'], data);
	  var allContentfulPage = R.prop('allContentfulPage', data);
	  var products = R.pathOr([], ['allContentfulPage', 'edges'], data);
	
	  if (allContentfulPage) {
	    products = R.filter(function (_ref2) {
	      var node = _ref2.node;
	      return R.equals(R.path(['template', '0', 'category'], node), category);
	    }, products);
	  }
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_Seo2.default, {
	      title: metaTitle,
	      canonicalUrl: canonicalUrl,
	      description: metaDescription
	    }),
	    _react2.default.createElement(_HireCategory2.default, { category: category, products: products }),
	    contactDetails && _react2.default.createElement(_ContactDetails2.default, { data: contactDetails })
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';
	
	exports.default = HireCategoryPage;

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-hire-category-js-bea3760dc19e39e2a338.js